// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu__submenu--1HsnA","submenuTextLink":"Submenu__submenuTextLink--2gGUG","submenuFeaturedLink":"Submenu__submenuFeaturedLink--2ZWuQ"};
    if(module.hot) {
      // 1605595234169
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  